'use strict';

declare var pdfMake: any;

module Patersons {

  export enum PdfFormatHint {
    None = 0,
    Currency,
    Currency4decPts,
  }

  class HeaderTable {
    public content: any;
    private rows: any[];

    constructor() {
      this.content = {
        style: { fontSize: 8 },
        margin: [-4, 8, 0, 5],
        table: {
          widths: ['auto', '*', 'auto', 'auto'],
          body: []
        }
      }
    }

    public addRow(nameLeft: string, valueLeft: string, nameRight: string, valueRight: string): HeaderTable {
      this.content.table.body.push([
        { border: [false, false, false, false], text: nameLeft, style: { bold: true, alignment: 'left', fontSize: 8 } },
        { border: [false, false, false, false], text: valueLeft, style: { bold: false, alignment: 'left', fontSize: 8  } },
        { border: [false, false, false, false], text: nameRight, style: { bold: true, alignment: 'right', fontSize: 8  } },
        { border: [false, false, false, false], text: valueRight, style: { bold: false, alignment: 'right', fontSize: 8.5  } }]
      );

      return this;
    }
  }

  class PdfTable {
    private tableTitle: any;
    private tableBody: any;
    private tableFooter: any;

    constructor(private userCompany: UserCompany){

    }

    public setTitle(titleText: string): PdfTable {
      let headerStyle: string = titleText ? 'filledHeader' : '';
      this.tableTitle = {
        style: "tableTitle",
        table: {
          widths: ['*'],
          body: [[{ text: titleText, style: headerStyle }]]
        },
        layout: 'noBorders'
      };
      return this;
    }

    public setNormalText(titleText: string): PdfTable {
      this.tableTitle = {
        table: {
          widths: ['*'],
          body: [[{ text: titleText }]]
        },
        layout: 'noBorders'
      };
      return this;
    }

    public setContent(dataRows: any[], fieldnames: string[], headings: string[], formatHints?: PdfFormatHint[], lastRowIsFooter?: boolean) {
      /*if (fieldnames.length !== headings.length) {
        throw new RangeError('Number of headings should match number of fields in the table.');
      }

      if (formatHints !== null && formatHints !== undefined && fieldnames.length !== formatHints.length) {
        throw new RangeError('Number of format hints should match number of fields in the table.');
      }*/

      let headerRow: any[];
      let content: any[][] = [];

      if (headings != null){
        headerRow = this.buildHeadings(headings);
        content.push(headerRow);
      }

      let bodyRows: any[][] = this.buildBody(dataRows, fieldnames, formatHints, lastRowIsFooter);
      content = content.concat(bodyRows);

      let columnWidths: string[] = this.calculateColumnWidths(fieldnames.length, content, lastRowIsFooter);
      if (content)
        this.tableBody = {
          layout: this.getTableLayout(headings, lastRowIsFooter),
          table: {
            widths: columnWidths,
            headerRows: 1,
            body: content
          }
        };

      return this;
    }

    getTableLayout(headings: any, lastRowIsFooter: boolean){
      if (headings && lastRowIsFooter){
        return {
          hLineWidth: (i, node) => { return 1; },
          hLineColor: (i, node) => {
            if (i === 1 || i === node.table.body.length - 1) { return this.userCompany.colorSecondary; }
            else { return 'lightgray'; }
          },
          vLineWidth: function(i, node) {
            return 0;
          }
        }
      }
      if (!lastRowIsFooter){
        return {
          hLineWidth: (i, node) => { return 1; },
          hLineColor: (i, node) => {
            if (i === 1) { return this.userCompany.colorSecondary; }
            else { return 'lightgray'; }
          },
          vLineWidth: function(i, node) {
            return 0;
          }
        }
      }
      else {
        return {
          hLineWidth: (i, node) => { return 1; },
          hLineColor: function(i, node) {
            if (i === node.table.body.length-1) { return 'lightgray'; }
            else { return 'lightgray'; }
          },
          vLineWidth: function(i, node) {
            return 0;
          }
        }
      }
    }

    public setContentAligned(dataRows: any[], fieldnames: string[], headings: any[], formatHints?: PdfFormatHint[], lastRowIsFooter?: boolean) {
      /*if (fieldnames.length !== headings.length) {
        throw new RangeError('Number of headings should match number of fields in the table.');
      }

      if (formatHints !== undefined && fieldnames.length !== formatHints.length) {
        throw new RangeError('Number of format hints should match number of fields in the table.');
      }*/

      let headerRow: any[];
      let content: any[][] = [];

      if (headings != null) {
        headerRow = this.buildHeadingsAligned(headings);
        content.push(headerRow);
      }

      let bodyRows: any[][] = this.buildBody(dataRows, fieldnames, formatHints, lastRowIsFooter);
      content = content.concat(bodyRows);

      let columnWidths: string[] = this.calculateColumnWidths(fieldnames.length, content, lastRowIsFooter);
      if (content)
        this.tableBody = {
          layout: this.getTableLayout(headings, lastRowIsFooter),
          table: {
            widths: columnWidths,
            headerRows: 1,
            body: content
          }
        };

      return this;
    }

    public hasTitle(): boolean {
      return this.tableTitle !== undefined;
    }

    public hasBody(): boolean {
      return this.tableBody !== undefined;
    }

    public getTitle(): any {
      return this.tableTitle;
    }

    public getBody(): any {
      return this.tableBody;
    }

    private buildHeadings(headings: string[]): any[] {
      let headerRow = [];
      for (let heading of headings) {
        headerRow.push({ border: [false, false, false, true], text: heading, style: 'tableHeader' });
      }
      return headerRow;
    }

    private buildHeadingsAligned(headings: any[]): any[] {
      let headerRow = [];
      for (let heading of headings) {
        if (heading.type === "number")
          headerRow.push({ border: [false, false, false, true], text: heading.text, style: 'tableHeaderNumeric' });
        else
          headerRow.push({ border: [false, false, false, true], text: heading.text, style: 'tableHeader' });
      }
      return headerRow;
    }

    private buildBody(dataRows: any[], fieldnames: string[], formatHints?: PdfFormatHint[], lastRowIsFooter?: boolean): any[][] {
      let tableContent: any[][] = [];
      for (let i = 0; i < dataRows.length; i++) {
        let dataRow = dataRows[i];
        let tableRow: any[] = [];
        for (let j = 0; j < fieldnames.length; j++) {
          let field: string = fieldnames[j];
          let formatHint: PdfFormatHint = (formatHints !== undefined && formatHints != null) ? formatHints[j] : PdfFormatHint.None;
          let isFooterRow: boolean = lastRowIsFooter && i === dataRows.length - 1;
          if (isFooterRow) {
            if (j === 0) {      //override first column label to be 'Total'
              dataRow[field] = "Total";
              formatHint = PdfFormatHint.None;
            }
            tableRow.push(this.buildTableFooterCell(dataRow[field], formatHint));
          } else {
            tableRow.push(this.buildTableCell(dataRow[field], formatHint));
          }
        }
        tableContent.push(tableRow);
      }
      return tableContent;
    }

    private buildTableCell(dataField: any, formatHint: PdfFormatHint): any {
      let cell: any = {
        border: [false, false, false, true],
        text: this.interpretFormatHint(dataField, formatHint),
        style: 'tableCell'
      };

      if (typeof dataField === 'number') {
        cell.style = 'tableCellNumeric';
      }

      return cell;
    }
    private buildTableFooterCell(dataField: any, formatHint: PdfFormatHint): any {
      if (!dataField) {
        dataField = "";
      }
      let cell: any = {
        text: this.interpretFormatHint(dataField, formatHint),
        "border": [false, true, false, false],
        style: 'footerCell'
      };

      if (typeof dataField === 'number') {
        cell.style = 'footerCellNumeric';
      }

      return cell;
    }

    private interpretFormatHint(dataField: any, formatHint: PdfFormatHint): string {
      if (!dataField) return "";

      switch (formatHint) {
        case PdfFormatHint.None:
          return dataField.toString();
        case PdfFormatHint.Currency:
          return this.formatAsCurrency(dataField);
        case PdfFormatHint.Currency4decPts:
          return this.formatAsCurrency4DecPts(dataField);
        default:
          return this.toString();
      }
    }

    addCommas(nStr): string {
        nStr = nStr + '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }

    private formatAsCurrency4DecPts(amount: any): string {
      /*if (value === null || value === undefined) {
        return undefined;
      }

      if (typeof value === 'number') {
        return value.toFixed(2);
      } else {
        return value;
      }*/
      if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
        return '';
      }
      return amount.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    }
    private formatAsCurrency(amount: any): string {
      /*if (value === null || value === undefined) {
        return undefined;
      }

      if (typeof value === 'number') {
        return value.toFixed(2);
      } else {
        return value;
      }*/
      if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
          return '';
      }
      var i: number = parseFloat(amount);
      if (isNaN(i)) {
          i = 0.00;
      }
      var minus = '';
      if (i < 0) { minus = '-'; }
      i = Math.abs(i);
      i = parseInt(((i + .005) * 100).toString());
      i = i / 100;
      var s = i.toString();
      if (s.indexOf('.') < 0) { s += '.00'; }
      if (s.indexOf('.') === (s.length - 2)) { s += '0'; }
      s = minus + s;
      return this.addCommas(s);
    }

    private calculateColumnWidths(numberOfColumns: number, tableContent: any[][], lastRowIsFooter?: boolean): string[] {
      let columnWidths: string[] = this.initialiseColumnWidths(numberOfColumns);

      let widestColumn: number = 0;
      for (let rowIndex = 0; rowIndex < tableContent.length; rowIndex++) {
        let row = tableContent[rowIndex];
        if (lastRowIsFooter && rowIndex === tableContent.length - 1) {  //do not use footer row as part of the width calculation
          continue;
        }
        for (let i = 0; i < row.length; i++) {
          if (row[i].text && row[widestColumn].text){
            if (row[i].text.length > row[widestColumn].text.length) {
              widestColumn = i;
            }
          }
        }
      }

      columnWidths[widestColumn] = '*';

      return columnWidths;
    }

    private initialiseColumnWidths(numberOfColumns: number): string[] {
      return Array.apply(null, Array<string>(numberOfColumns)).map(v => 'auto');
    }
  }

  export class PdfBuilder {
    public docDefinition: any;
    private filename: string;
    private titleText: string;
    private subTitleText: string;
    private headings: string[];
    private tables: PdfTable[];
    private headerTable: HeaderTable;
    public styles : any;
    public base64logo : any;
    private footer: string[];
    public userCompany: UserCompany;

    constructor(base64logo:string, userCompany: UserCompany) {
      this.filename = this.generateDefaultFilename();
      this.headings = new Array<string>();
      this.footer = new Array<string>();
      this.tables = new Array<PdfTable>();
      this.headerTable = new HeaderTable();
      this.base64logo = base64logo;
      this.userCompany = userCompany;
      this.styles = {
          logo: {
            margin: [0, 0, 0, 10],
            alignment: 'right'
          },
          tableTitle: {
            fontSize: 8,
            margin: [0, 15, 0, 0]
          },
          header: {
            fontSize: 16,
            bold: false,
            margin: [0, 0, 0, 0],
            color: userCompany.colorSecondary
          },
          filledSubHeader: {
            bold: true,
            fontSize: 8,
            color: 'black',
            fillColor: '#D8D8D8',
            margin: [5, 2, 2, 2],
            alignment: 'left'
          },
          subHeader: {
            fontSize: 13,
            bold: false,
            margin: [0, 5, 0, 10],
            color: userCompany.colorSecondary
          },
          headerText: {
            margin: [0, 0, 0, 3],
            fontSize: 6,
          },
          footerText: {
            fontSize: 5,
            bold: false,
            alignment: 'center'
          },
          tableHeader: {
            fontSize: 8,
            bold: true,
            color: userCompany.colorSecondary,
            //margin: [2, 5, 0, 10],
          },
          tableHeaderNumeric: {
            fontSize: 8,
            bold: true,
            color: userCompany.colorSecondary,
            alignment: 'right'
            //margin: [2, 5, 0, 10],
          },
          filledHeader: {
            bold: true,
            fontSize: 8,
            color: 'white',
            fillColor: userCompany.colorSecondary,
            margin: [5, 2, 2, 2],
            alignment: 'left'
          },
          filledHoldingsHeader: {
              bold: true,
              fontSize: 8,
              color: 'black',
              fillColor: 'lightgray',
              margin: [10, 2, 2, 2],
          },
          footerCell: {
            bold: true,
            border: [false, false, false, false],
            fontSize: 8,
            alignment: 'left'
          },
          tableCell: {
            fontSize: 8,
            margin: [0, 0, 0, 0],
            alignment: 'left'
          },
          tableCellBold: {
            fontSize: 8,
            bold: true,
            margin: [0, 0, 0, 0],
            alignment: 'left'
          },
          tableCellNumeric: {
            fontSize: 8,
            margin: [0, 0, 0, 0],
            alignment: 'right'
          },
          footerCellNumeric: {
            bold: true,
            border: [false, false, false, false],
            fontSize: 8,
            alignment: 'right'
          },
          numericValue: {
            alignment: 'right'
          }
      };

      this.docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [ 56, 28, 56, 70 ],
        style: { font: 'arial' },
        content: [
          this.getImageContent()
        ],
        styles: this.styles,
        footer: function(currentPage, pageCount, pageSize) {
          var footerPDF = userCompany && userCompany.footerPDF;
          var footerDisclaimerItems = [];
          if(footerPDF){
            var $elem = $("<div>" + footerPDF + "<div>");
            $("p", $elem).each(function(){
              footerDisclaimerItems.push({
                text: $(this).text(),
                style: 'footerText'
              })
            })
          }
          var footer: any = [
              {
                 "fontSize": 1,
                  margin: [56, 0, 56, 5],
                  layout: {
                       hLineColor: function(i, node) {
                            return 'lightgray';
                       }
                   },
                 "table":{
                     "widths":["*"],
                     "headerRows": 1,
                     "body":
                     [
                         [
                             {"border": [false, false, false, true], "text":" ","alignment":"left"},
                         ],
                     ]
                 }
              },
            ]
            footer = footer.concat(footerDisclaimerItems)
            footer.push({
              margin: [56, 0, 56, 0],
              style: { fontSize: 5 },
              table: {
                widths: ['*', '*'],
                body: [
                  [
                    { "border": [false, false, false, false], 'text': moment().tz('Australia/Sydney').format('D MMM YYYY h:mm:ss A [AEST]'), "style": { 'alignment': 'left' } },
                    { "border": [false, false, false, false], 'text': 'Page ' + currentPage + ' of ' + pageCount, "style": { 'alignment': 'right' } }
                  ]
                ]
              }
            })
            return footer
        }
      };
    }

    public getImageContent() {
      return {
        image: this.base64logo,
        style: this.styles.logo,
        width: 141,
        height: 43
      }
    }

    public setFilename(filename: string): PdfBuilder {
      this.filename = filename;
      return this;
    }

    public setTitle(titleText: string): PdfBuilder {
      this.titleText = titleText;
      return this;
    }

    public setSubTitle(subTitleText: string): PdfBuilder {
      this.subTitleText = subTitleText;
      return this;
    }

    public addHeaderTableRow(nameLeft: string, valueLeft: string, nameRight: string, valueRight: string): PdfBuilder {
      this.headerTable.addRow(nameLeft, valueLeft, nameRight, valueRight);
      return this;
    }

    public addHeading(headingText: string): PdfBuilder {
      this.headings.push(headingText);
      return this;
    }

    public addFooter(footerText: string): PdfBuilder {
      this.footer.push(footerText);
      return this;
    }

    public addTable(
      titleText: string,
      dataRows: any[],
      fieldNames: string[],
      headings: string[],
      formatHints?: PdfFormatHint[],
      lastRowIsTotal?: boolean): PdfBuilder {
      let table: PdfTable = new PdfTable(this.userCompany);
      if (dataRows == null) {
        dataRows = [];
      }

      if (!dataRows || dataRows.length === 0) {
        return this;
        //this.addNormalText("There is no data available");
      }

      this.tables.push(table
        .setTitle(titleText)
        .setContent(dataRows, fieldNames, headings, formatHints, lastRowIsTotal));

      return this;
    }

    public addTableAligned(titleText: string, dataRows: any[], fieldNames: string[], headings: any[], formatHints?: PdfFormatHint[], lastRowIsTotal?: boolean): PdfBuilder {
      let table: PdfTable = new PdfTable(this.userCompany);
      if (dataRows == null) {
        dataRows = [];
      }

      if (!dataRows || dataRows.length === 0) {
          return this;
      }

      this.tables.push(table
        .setTitle(titleText)
        .setContentAligned(dataRows, fieldNames, headings, formatHints, lastRowIsTotal));

      return this;
    }

    public addNormalText(titleText: string): PdfBuilder {
      let table: PdfTable = new PdfTable(this.userCompany);
      this.tables.push(table.setNormalText(titleText));
      return this;
    }

    // Optionally pass in a pre-built document definition, which is just an array
    // of content items, as supported by PdfMake.
    public build(injectedContent?: any[]): any {
      this.pushTitle();
      this.pushSubTitle();
      this.pushHeaderTable();
      this.pushAllHeadings();

      if (injectedContent && injectedContent.length > 0) {
        this.injectContent(injectedContent);
      } else {
        this.pushAllTables();
      }

      //this.pushFooter();
      //console.log(JSON.stringify(this.docDefinition.content));

      return pdfMake.createPdf(this.docDefinition).download(this.filename + '.pdf');
    }

    // Optionally pass in a pre-built document definition, which is just an array
    // of content items, as supported by PdfMake.
    public buildContent(injectedContent?: any[]): any {
      this.pushTitle();
      this.pushSubTitle();
      this.pushHeaderTable();
      this.pushAllHeadings();

      if (injectedContent && injectedContent.length > 0) {
        this.injectContent(injectedContent);
      } else {
        this.pushAllTables();
      }

      //this.pushFooter();
      return this.docDefinition
    }

    private pushTitle(): void {
      if (this.titleText !== undefined) {
        this.docDefinition.content.push({ text: this.titleText, style: 'header' });
      }
    }

    private pushSubTitle(): void {
      if (this.subTitleText !== undefined) {
        this.docDefinition.content.push({ text: this.subTitleText, style: 'subHeader' });
      }
    }

    private pushHeaderTable(): void {
      if (this.headerTable !== undefined) {
        this.docDefinition.content.push(this.headerTable.content);
      }
    }

    private pushAllHeadings(): void {
      let i: number;
      for (i = 0; i < this.headings.length; i++) {
        this.docDefinition.content.push({ text: this.headings[i], style: 'headerText' });
      }
    }

    getFooter(){
      let footerContent = [];
      let i: number;
      if (this.footer.length > 0){
        footerContent.push({ text: ' ', fontSize: 8 });
        // add footer line
        footerContent.push({
           "fontSize": 8,
            layout: {
                 hLineColor: function(i, node) {
                      return 'lightgray';
                 }
             },
           "table":{
               "widths":["*"],
               "headerRows":1,
               "body":
               [
                   [
                       {"border": [false, false, false, true], "text":" ","alignment":"left"},
                   ],
               ]
           }
        });
        footerContent.push({ text: ' ', fontSize: 5 });
      }
      for (i = 0; i < this.footer.length; i++) {
        footerContent.push({ text: this.footer[i], style: 'footerText' });
      }

      return footerContent;
    }

    private pushFooter(): void {
      let i: number;
      if (this.footer.length > 0){
        this.docDefinition.content.footer.push({ text: ' ', fontSize: 8 });
        // add footer line
        this.docDefinition.content.footer.push({
           "fontSize": 8,
            layout: {
                 hLineColor: function(i, node) {
                      return 'lightgray';
                 }
             },
           "table":{
               "widths":["*"],
               "headerRows":1,
               "body":
               [
                   [
                       {"border": [false, false, false, true], "text":" ","alignment":"left"},
                   ],
               ]
           }
        });
        this.docDefinition.content.footer.push({ text: ' ', fontSize: 5 });
      }
      for (i = 0; i < this.footer.length; i++) {
        this.docDefinition.content.footer.push({ text: this.footer[i], style: 'footerText' });
      }
    }

    private injectContent(injectedContent: any[]) {
      this.docDefinition.content = this.docDefinition.content.concat(injectedContent);
    }

    private pushAllTables(): void {
      for (let table of this.tables) {
        if (table.hasTitle()) {
          this.docDefinition.content.push(table.getTitle());
        }

        if (table.hasBody()) {
          this.docDefinition.content.push(table.getBody());
        }
      }
    }

    private generateDefaultFilename(): string {
      // Generate a pseudorandom 16-character string using [0-9a-z].
      let randomString: string = (Math.random().toString(36) + '00000000000000000').slice(2, 18);
      let timeStamp: Date = new Date();

      return randomString + '-' + timeStamp.toISOString();
    }
  }
}
